exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#exports-modal .modal-body {\n    overflow-y: visible;\n}\n#exports-modal .modal-export-item>td {\n    vertical-align: middle;\n}\n#exports-modal .entities-td {\n    width: 50%;\n}\n#exports-modal .ma0 {\n    margin: 0;\n}\n#exports-modal .modal-export-item .btn[data-toggle=\"popover\"] {\n    margin-left: 5px;\n}\n", ""]);

// exports
